<template>
    <div class="slider">
        <div class="slider__controls">
            <button class="slider__controls-prev" @click="prevSlide">
                <i class="fas fa-chevron-left"></i>
            </button>
            <button class="slider__controls-next" @click="nextSlide">
                <i class="fas fa-chevron-right"></i>
            </button>
        </div>
        <div v-swipe="onSwipe" class="slider__slides u-clearfix">
            <button class="slider__expand">
                <i class="icon-expand"></i>
            </button>
            <slot name="slides"></slot>
            <div class="slider__pagination">
                <span class="slider__pagination-dot" :class="{ 'slider__pagination-dot--active': index === key }" v-for="(slide, key) in slides" @click="goTo(key)"></span>
            </div>
        </div>
        <div class="slider__caption u-clearfix">
            <slot name="captions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        provide() {
            return {
                $slider: this
            };
        },
        data() {
            return {
                index: 0,
                prevIndex: null,
                slides: 0,
                sliding: false
            };
        },
        created() {
            this.slides = this.$slots.slides.filter(e => e.componentOptions);

            this.slides.forEach((slide, index) => {
                slide.componentOptions.propsData.index = index;
            });

            if (typeof this.$slots.captions !== 'undefined') {
                this.captions = this.$slots.captions.filter(e => e.componentOptions);
                this.captions.forEach((slide, index) => {
                    slide.componentOptions.propsData.index = index;
                });
            }
        },
        mounted() {
            let vm = this;
            for (let i = 0; i < this.slides.length; i++) {
                let slide = this.slides[i];

                slide.elm.addEventListener("transitionend", () => {
                    vm.sliding = false;
                });
            }
        },
        methods: {
            goTo(slide) {
                this.sliding = true;
                this.prevIndex = this.index;

                let start = 0;
                let end = this.slides.length - 1;

                if (slide > end) {
                    slide = start;
                }

                if (slide < start) {
                    slide = end;
                }

                this.index = slide;
            },
            nextSlide() {
                this.goTo(this.index + 1);
            },
            prevSlide() {
                this.goTo(this.index - 1);
            },
            onSwipe(event) {
                if (event.direction === 2) {
                    this.nextSlide();
                } else if (event.direction === 4) {
                    this.prevSlide();
                }
            }
        }
    };
</script>

<style lang="scss">
    @import '../../sass/abstracts/variables';
    @import '../../sass/abstracts/media-queries';

    .slider {
        position: relative;

        &__expand {
            display: none; // TODO: Do we need to hook these up to full screen galleries?
            background: transparent;
            border: none;
            color: $white;
            cursor: pointer;
            font-size: 3.3rem;
            padding: 1.2rem;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 10;

            @include laptop {
                display: none;
            }
        }

        &__slides {
            height: 100%;
            position: relative;
        }

        &__caption {
            margin: 2rem;
            position: relative;

            @include laptop {
                display: none;
            }
        }

        &__controls {
            position: absolute;
            right: 1rem;
            top: -4rem;
            z-index: 10;

            @include laptop {
                right: 2rem;
                top: -6.7rem;
            }

            &-prev, &-next {
                background-color: transparent;
                border: none;
                color: $gray-light;
                cursor: pointer;
                font-size: 1.8rem;
                line-height: 1.8rem;
                margin: 0;
                padding: 1rem;
                user-select: none;
                width: auto;

                @include laptop {
                    font-size: 2.7rem;
                    line-height: 1em;
                    padding: 2rem;
                }
            }

            &-prev:disabled, &-next:disabled {
                color: $gray-lighter;
                cursor: initial;
            }
        }

        &__pagination {
            bottom: 1.4rem;
            display: flex;
            left: 2rem;
            position: absolute;
            z-index: 10;

            @include laptop {
                bottom: auto;
                flex-direction: column;
                left: auto;
                right: 1.4rem;
                top: 2rem;
            }

            &-dot {
                background-color: transparent;
                border: 0.1rem solid rgba(250, 250, 250, 0.6);
                border-radius: 50%;
                cursor: pointer;
                height: 1.4rem;
                margin: 0.2rem;
                transition: background-color 0.6s ease;
                width: 1.4rem;

                &--active {
                    background-color: $white !important;
                    border: 0.1rem solid $white;

                    @include laptop {
                        border: 0.1rem solid $gray-light;
                    }
                }

                @include laptop {
                    background-color: rgba(250, 250, 250, 0.6);
                    border: 0.1rem solid $gray-light;
                    height: 2.2rem;
                    margin: 0.6rem;
                    width: 2.2rem;
                }
            }
        }
    }
</style>
